import { useEmployees } from '@Page/SalaryRun/hooks/useEmployees.ts';
import { Filter, FilterState } from '@Component/Filter/utils';

export function useHasFilter(selectedPeriod: Date, filter: Filter): boolean {
    const filterState: FilterState = {
        stringFilter: filter,
    };
    return (
        useEmployees({
            year: selectedPeriod.getFullYear(),
            month: selectedPeriod.getMonth() + 1,
            filters: filterState,
        }).data.length > 0
    );
}
